import i18n from "../utils/i18n";

export const LANG = (key) => {
  return i18n.t(key);
};